import React, { FC } from "react";
import Checkbox from "components/atoms/Checkbox";
import Chip from "components/atoms/Chip";
import "styles/filter-set.scss";
import cx from "classnames";
import { FilterSetProps, REOptionType } from "types/molecules.types";

const FilterSet: FC<FilterSetProps> = ({
  title,
  desc,
  options,
  onChange,
  selectedCheckboxData,
  isChip,
  isEdit,
  onRemove,
  onEdit,
  className,
}) => {
  const hasEditClass = cx({ has_edit: isEdit });

  return (
    <div className="asr-filter-set">
      <div className={hasEditClass}>
        <h3 className={`title ${className}`}>{title}</h3>
        {isEdit && (
          <h3 className="title edit" onClick={onEdit}>
            Edit
          </h3>
        )}
      </div>
      {desc && <p>{desc}</p>}
      {isEdit && isChip ? (
        selectedCheckboxData &&
        selectedCheckboxData.map((option: REOptionType, i: number) => (
          <span key={i}>
            <Chip option={option} onRemove={onRemove} />
          </span>
        ))
      ) : (
        <ul>
          {options.map((option, i) => (
            <li key={i}>
              <Checkbox
                title={title}
                inputId={option.id}
                name={option.name}
                onChange={onChange}
                ischecked={selectedCheckboxData?.includes(
                  title === "Category" ? option : option
                )}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default FilterSet;
